import helpdesk from "./img/works/helpdesk.png";
import twitter from "./img/works/twitter.png";
import amazona from "./img/works/amazona.png";
import calculator from "./img/works/calculator.PNG";
import chatbot from "./img/works/chatbot.PNG";
import dashboard from "./img/works/dashboard.png";
import hrmis1 from "./img/works/hrmis1.png";
import hrmis from "./img/works/hrmis2.png";
import reception from "./img/works/reception.png";
import tts from "./img/works/tts.png";
import img1 from "./img/works/1.png";
import img2 from "./img/works/2.png";
import img3 from "./img/works/3.png";
import img4 from "./img/works/4.png";
import img5 from "./img/works/5.png";
import img6 from "./img/works/6.png";
import img7 from "./img/works/7.png";
import img8 from "./img/works/8.png";
import img9 from "./img/works/1.png";
import img10 from "./img/works/10.png";
import img11 from "./img/works/11.png";
import chathouse from "./img/works/chathouse.png";
export const sliderItems = [
  {
    id: 1,
    img: "./imgs/4.jpg",
    title: "Programming",
    desc: "Life without programming is not complate!",
    bg: "f5fafd",
  },
  {
    id: 2,
    img: "./imgs/1.jpg",
    // title: "Programming",
    // desc: "Life without programming is not complate !",
    bg: "fcf1ed",
  },
  {
    id: 3,
    img: "./imgs/11.png",
    // title: "Programming",
    // desc: "Life without programming is not complate !",
    bg: "fbf0f4",
  },
];

export const products = [
  {
    id: 22,
    img: chathouse,
    link: "https://github.com/Rahmat-fayeq/",
  },
  {
    id: 1,
    img: twitter,
    link: "https://twitter7.vercel.app/",
  },
  {
    id: 2,
    img: amazona,
    link: "https://ecom5.vercel.app",
  },
  {
    id: 3,
    img: helpdesk,
    link: "https://github.com/Rahmat-fayeq",
  },
  {
    id: 4,
    img: calculator,
    link: "https://github.com/Rahmat-fayeq",
  },
  {
    id: 5,
    img: chatbot,
    link: "https://github.com/Rahmat-fayeq",
  },
  {
    id: 6,
    img: tts,
    link: "https://github.com/Rahmat-fayeq",
  },
  {
    id: 7,
    img: reception,
    link: "https://github.com/Rahmat-fayeq",
  },
  {
    id: 8,
    img: hrmis1,
    link: "https://github.com/Rahmat-fayeq",
  },
  {
    id: 9,
    img: hrmis,
    link: "https://github.com/Rahmat-fayeq",
  },
  {
    id: 10,
    img: dashboard,
    link: "https://github.com/Rahmat-fayeq",
  },
  {
    id: 11,
    img: img1,
    link: "https://github.com/Rahmat-fayeq",
  },
  {
    id: 12,
    img: img2,
    link: "https://github.com/Rahmat-fayeq",
  },
  {
    id: 13,
    img: img3,
    link: "https://github.com/Rahmat-fayeq",
  },
  {
    id: 14,
    img: img4,
    link: "https://github.com/Rahmat-fayeq",
  },
  {
    id: 15,
    img: img5,
    link: "https://github.com/Rahmat-fayeq",
  },
  {
    id: 16,
    img: img6,
    link: "https://github.com/Rahmat-fayeq",
  },
  {
    id: 17,
    img: img7,
    link: "https://github.com/Rahmat-fayeq",
  },
  {
    id: 18,
    img: img8,
    link: "https://github.com/Rahmat-fayeq",
  },
  {
    id: 19,
    img: img9,
    link: "https://github.com/Rahmat-fayeq",
  },
  {
    id: 20,
    img: img10,
    link: "https://github.com/Rahmat-fayeq",
  },
  {
    id: 21,
    img: img11,
    link: "https://github.com/Rahmat-fayeq",
  },
];
